export default __webpack_public_path__ + "static/media/comfy.dcba4973.png";